/* eslint-disable max-len */
import PinPlateRequestData from '../duplicate-pin-plate-admin-search/state/duplicatePinPlateSearchRequest';

export const createPinPlateRequest = (pinPlateDetails) => {

    let PinPlateObj = {};

    const dealerpin = pinPlateDetails.pins ? pinPlateDetails.pins.split(',') : [];
    const dealerAccount = pinPlateDetails.dealerAccounts ? pinPlateDetails.dealerAccounts.split(',') : [];
    const dealerTcsmId = pinPlateDetails.requesterTCSMs ? pinPlateDetails.requesterTCSMs.split(',') : [];
    const dealerFactory = pinPlateDetails.factoryCodes ? pinPlateDetails.factoryCodes.split(',') : [];
    const pinPlateStatus = pinPlateDetails.status ? pinPlateDetails.status.split(',') : [];

    if (pinPlateDetails.pins !== '') {

        PinPlateObj = { ...PinPlateObj, pins: dealerpin };

    }

    // Dates: convert to epoch if present and not empty
    if (pinPlateDetails.fromDateSubmmited !== '') {

        PinPlateObj = { ...PinPlateObj, fromDateSubmmited: Date.parse(pinPlateDetails.fromDateSubmmited) };

    }
    if (pinPlateDetails.toDateSubmmited !== '') {

        PinPlateObj = { ...PinPlateObj, toDateSubmmited: Date.parse(pinPlateDetails.toDateSubmmited) };

    }
    if (pinPlateDetails.fromUpdatedTs !== '') {

        PinPlateObj = { ...PinPlateObj, fromUpdatedTs: Date.parse(pinPlateDetails.fromUpdatedTs) };

    }
    if (pinPlateDetails.toUpdatedTs !== '') {

        PinPlateObj = { ...PinPlateObj, toUpdatedTs: Date.parse(pinPlateDetails.toUpdatedTs) };

    } else if (pinPlateDetails.dealerAccounts !== '') {

        PinPlateObj = { ...PinPlateObj, dealerAccounts: dealerAccount };

    }
    if (pinPlateDetails.requesterTCSMs !== '') {

        PinPlateObj = { ...PinPlateObj, requesterTCSMs: dealerTcsmId };

    } if (pinPlateDetails.factoryCodes !== '') {

        PinPlateObj = { ...PinPlateObj, factoryCodes: dealerFactory };

    } if (pinPlateDetails.status !== '') {

        PinPlateObj = { ...PinPlateObj, status: pinPlateStatus };

    }
    return new PinPlateRequestData({
        ...PinPlateObj,
    });

};
